<template>
  <div>
    <div class="cate-list-container">
      <div class="cate-item-container">
        <div class="cate-item-wrapper" v-for="(el, idx) in bizCateList" :zz-sortid="idx" :zz-sortname="el.categoryNameForUser" :key="el.businessCategoryId">
          <div
            :class="selectedClass(el.businessCategoryId)"
            @click="() => changeBizCate(el)"
          >
            <img :src="$setPicSize(el.avatar)" class="cate-image"/>
            <p class="cate-text" :class="{'bigName': bigFontSize}">{{el.categoryNameForUser}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'

export default {
  name: 'BizCategory',
  props: {
    needRedBorder: { // 是否采用选中突出效果
      type: Boolean,
      default: false
    },
    bizCateList: {
      type: Array,
      default: () => []
    },
    curBizCate: {
      type: Object
    },
    bigFontSize: { // 控制组件业务名称字号
      type: Boolean
    }
  },
  computed: {
    selectedClass() {
      return (id) => {
        // console.log('compClass', id, this.curBizCate)
        const tempClass = ['cate-item']
        if (id === this.curBizCate.businessCategoryId && this.needRedBorder) {
          tempClass.push('cate-item-active')
        }
        return tempClass
      }
    }
  },
  methods: {
    changeBizCate(bizCate) {
      this.$emit('changeBizCate', bizCate)
    },
    $setPicSize(url) {
      return setPicSize(url)
    }
  }

}

</script>
<style scoped lang="less">
  @import 'index.less';
</style>